module.exports = __webpack_public_path__ + "img/certificate-mobile_degree_platinum.8b164f43.png";